/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import './style/footer.scss';

import React from 'react';
import {Carousel} from 'react-responsive-carousel';
import {getImg, pageScroller} from "../../util/utils";
import testimonials from "../../util/testimonials";
import {Testimonial} from "../../util/interfaces";
import {getHeaderItems} from "../../routes";
import {HeaderItem, sendGaEvent} from '@dvrd/dvr-controls';
import Facebook from "../misc/facebook";
import {useNavigate} from 'react-router';
import {afterNavigate} from "../../util/navigationUtil";

const SLIDE_INTERVAL = 10000;

export default function Footer() {
    const navigate = useNavigate();

    function onClickNav(item: HeaderItem) {
        return function () {
            sendGaEvent('click', 'footer', item.label);
            afterNavigate(item.route, true, item.id, pageScroller, navigate);
        }
    }

    function onClickMail() {
        sendGaEvent('click', 'footer', 'email');
    }

    function onClickTel() {
        sendGaEvent('click', 'footer', 'tel');
    }

    function onClickLogo() {
        afterNavigate('/', true, '', pageScroller, navigate);
    }

    function getRatingWidth(rating: Testimonial): number {
        return Math.max(0, rating.rating) / 5 * 100;
    }

    function renderRatings() {
        if (!testimonials.length) return null;
        return (
            <div className='testimonials-container'>
                <Carousel autoPlay infiniteLoop showArrows={false} showIndicators={false} showStatus={false}
                          showThumbs={false} stopOnHover className='testimonials' interval={SLIDE_INTERVAL}>
                    {testimonials.map(renderRating)}
                </Carousel>
            </div>
        )
    }

    function renderRating(rating: Testimonial, index: number) {
        return (
            <div key={index}>
                <div className='message-container'>
                    <p className='testimonial-message'>{rating.message}</p>
                    <div className='stars-container'>
                        <span style={{width: getRatingWidth(rating) + '%'}}/>
                    </div>
                </div>
                <label className='testimonial-name'>{rating.name}</label>
            </div>
        )
    }

    function renderCompany() {
        return (
            <div className='footer-content company'>
                <div className='company-info-container'>
                    <label className='company-label'>Bowie's Hondenuitlaatservice</label>
                    <label>KvK nummer:</label>
                    <label>80330509</label>
                    <label>BTW-id:</label>
                    <label>NL003423654B13</label>
                    <label>E-mailadres:</label>
                    <a href='mailto:info@bowies.nl' className='link' onClick={onClickMail}>info@bowies.nl</a>
                    <label>Telefoonnummer</label>
                    <a href='tel:+31654716533' className='link nb' onClick={onClickTel}>06-54716533</a>
                    <Facebook/>
                </div>
            </div>
        )
    }

    function renderPages() {
        return (
            <div className='footer-content navigation'>
                <div className='navigation-container'>
                    {getHeaderItems().map((nav: HeaderItem, index: number) => (
                        <label key={index} className='nav' onClick={onClickNav(nav)}>{nav.label}</label>
                    ))}
                </div>
            </div>
        )
    }

    return (
        <div className='page-footer'>
            {renderRatings()}
            <div className='footer-container'>
                {renderCompany()}
                <div/>
                <div className='footer-content logo'>
                    <img src={getImg('bowies_logo_excl-x338')} alt="Bowie's" className='logo-container click'
                         onClick={onClickLogo}/>
                </div>
                {renderPages()}
            </div>
        </div>
    )
}